import { ClientServiceProvider } from '../../../modules/clients/services/client-service/client-service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EventsServiceProvider,
  SellionsEvent,
} from '../../../modules/calendar/services/events-service/events-service';
import { IClientModel } from '../../../modules/clients/interfaces/i-client-model.interface';
import { IRecipient } from '../../../modules/clients/interfaces/i-recipient.interface';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';

@Component({
  selector: 'sellions-event',
  templateUrl: 'sellions-event.html',
})
export class SellionsEventComponent {
  @Output() eventClicked = new EventEmitter<SellionsEvent>();
  @Input() set event(event: SellionsEvent) {
    this._event = event;
    this.client = this.clientService.getById(event.clientId);
    if (
      this.client &&
      this.client.recipients &&
      this.client.recipients.length
    ) {
      this.recipient = this.client.recipients.find(
        (recipient) => recipient.id === event.recipientId,
      );
    }
  }
  @Input() showClientName: boolean = true;

  _event: SellionsEvent;
  recipient: IRecipient;
  client: IClientModel;

  constructor(
    private clientService: ClientServiceProvider,
    public eventsService: EventsServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  showEventDetail(event: SellionsEvent) {
    this.eventClicked.emit(event);
  }

  getColorForEventState(state: string): string {
    switch (state) {
      case 'PLANNED':
        return '#ff0000';
      case 'COMPLETED':
        return '#008000';
    }
    return '#00aaff';
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-event/sellions-event.ts